module.exports = __webpack_public_path__ + "static/Poppins-Bold-a3e0b5f427803a187c1b62c5919196aa.ttf";